'use strict';

/**
 * @ngdoc function
 * @name sharedModule.directive:contactUs
 * @description
 * # Contact Us
 * Directive of the sharedModule
 */
(function (angular, window, undefined) {
  function contactUs($window, $rootScope, $location, LoginService, SHOW, ContactUsService, DocumentService) {
    'ngInject'

    var directive = {
      link: link,
      restrict: 'E',
      scope: {
        
      },
      templateUrl: (window.location.hostname === 'localhost' ? '/app/' : '') + 'views/shared/contactUs.html',
      bindToController: true,
      controller: controller,
      controllerAs: 'ContactUsCtrl'
    };
    return directive;

    function controller() {
      'ngInject';//must be first line in function... needed by ng-annotate
    }

    function link(scope, element, attrs) {
      var self = directive.controllerAs ? scope[directive.controllerAs] : scope;

      self.contactModel = {
        eventName: '',
        eventCode: '',
        firstName: '',
        lastName: '',
        company: '',
        emailFrom: '',
        phone: '',
        reason: '',
        question: ''
      };

      self.validShow = false;

      self.focusShow = true;

      self.errors = LoginService.data.messages;

      LoginService.getShowsByName({
        showName: self.showName || ''
      }).then(function () {
        if (LoginService.data.shows) {
          self.showList = LoginService.data.shows;

          var dupeShows = _.filter(self.showList, function (s) {
            return _.any(self.showList, function (s1) { return s1.ShowCode !== s.ShowCode && s1.TradeShowName.trim() === s.TradeShowName.trim(); });
          });

          self.showList = _.map(self.showList, function (s) {
            var newShow = angular.copy(s);

            if (_.filter(dupeShows, function (d) { return d.ShowCode === newShow.ShowCode; })) {
              try {
                var openDate = new Date(newShow.ShowOpenDate);
                var month = openDate.getMonth() + 1;
                if (openDate.getFullYear() === 1)
                  newShow.TradeShowName = s.TradeShowName;
                else
                  newShow.TradeShowName = s.TradeShowName + ' (' + month + '/' + openDate.getFullYear() + ')';
              } catch (e) {
                newShow.TradeShowName = s.TradeShowName;
              }
            }

            return newShow;
          });

          if (SHOW && SHOW.ShowCode && _.any(self.showList, function (s) { return s.ShowCode === SHOW.ShowCode; })) {
            self.showName = SHOW.TradeShowName || null;
            self.showCode = SHOW.ShowCode;
          }
        }
        else
          self.showList = [];
      });
      scope.$watch('ContactUsCtrl.showName', function (newval, oldval) {
        var valid = _.uniq(_.filter(self.showList, function (s) {
          return s.TradeShowName === newval;
        }), function (show) {
          return show.ShowCode;
        });
        self.validShow = valid && valid.length === 1;

        if (self.validShow) {
          self.showCode = valid[0].ShowCode;
          self.contactModel.eventName = valid[0].TradeShowName;
          self.contactModel.eventCode = self.showCode
          ContactUsService.getContactUsReasonsByShowCode({
            showCode: self.showCode
          }).then(function () {
            if (ContactUsService.data.reasons) {
              self.reasonsList = ContactUsService.data.reasons;
            }
          });
        } else {
          self.showCode = null;
          self.errors = [];
          ContactUsService.getContactUsReasonsByShowCode()
            .then(function () {
              if (ContactUsService.data.reasons) {
                self.reasonsList = ContactUsService.data.reasons;
              }
            })
        }
      });

      self.send = function () {
        if (!DocumentService.checkFormIsValid(self.formContactUs))
          return;

        return ContactUsService.sendEmail({
          data: angular.extend(self.contactModel)
        })
          .then(function (result) {
            window.alert('Success!');
            self.success = true;
          }, function (errors) {
            window.alert('There was an error submitting your customer service request.');
          });
          
      };
    }
  }
  angular.module('sharedModule')
    .directive('contactUs', contactUs);
})(angular, window);
